"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.date.to-string");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _formElements = require("@evidation/form-elements");

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var fieldBlur = function fieldBlur(password, confirm) {
  return password === confirm ? password : false;
};

var Password = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Password, _PureComponent);

  var _super = _createSuper(Password);

  function Password(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Password);
    _this = _super.call(this, props);
    _this.state = {
      password: "",
      confirm: ""
    };
    return _this;
  }

  (0, _createClass2["default"])(Password, [{
    key: "onChange",
    value: function onChange() {
      var _this$state = this.state,
          password = _this$state.password,
          confirm = _this$state.confirm;

      if (password === confirm) {
        this.props.input.onChange(password);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$meta = _this$props.meta,
          _this$props$meta$asyn = _this$props$meta.asyncValidating,
          asyncValidating = _this$props$meta$asyn === void 0 ? false : _this$props$meta$asyn,
          active = _this$props$meta.active,
          valid = _this$props$meta.valid,
          touched = _this$props$meta.touched,
          _this$props$input = _this$props.input,
          onFocus = _this$props$input.onFocus,
          _onBlur = _this$props$input.onBlur;
      var _this$state2 = this.state,
          password = _this$state2.password,
          confirm = _this$state2.confirm;

      var _util_commonInputPara = (0, _utils.util_commonInputParamters)(this.props),
          _util_commonInputPara2 = _util_commonInputPara.error,
          error = _util_commonInputPara2 === void 0 ? "" : _util_commonInputPara2,
          onChange = _util_commonInputPara.onChange,
          fieldProps = (0, _objectWithoutProperties2["default"])(_util_commonInputPara, ["error", "onChange"]);

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_formElements.TextInput, (0, _extends2["default"])({}, fieldProps, {
        id: "t-password",
        value: password,
        onChange: function onChange(_ref) {
          var password = _ref.target.value;
          return _this2.setState({
            password: password
          }, function () {
            return _this2.onChange();
          });
        },
        placeholder: "Password",
        type: "password",
        onBlur: function onBlur() {
          if (password !== "" && confirm !== "") {
            return _onBlur(fieldBlur(password, confirm));
          }
        },
        onFocus: onFocus
      })), /*#__PURE__*/_react["default"].createElement(_formElements.TextInput, (0, _extends2["default"])({}, fieldProps, {
        id: "t-passwordConfirm",
        value: confirm,
        label: "",
        onChange: function onChange(_ref2) {
          var confirm = _ref2.target.value;
          return _this2.setState({
            confirm: confirm
          }, function () {
            return _this2.onChange();
          });
        },
        placeholder: "Confirm Password",
        type: "password",
        onBlur: function onBlur() {
          if (password !== "" && confirm !== "") {
            return _onBlur(fieldBlur(password, confirm));
          }
        },
        onFocus: onFocus
      })), asyncValidating && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        id: "t-passwordConfirm-message",
        style: {
          color: "gray"
        }
      }, "Validating password..."), !asyncValidating && !active && touched && valid && password !== "" && confirm !== "" && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
        id: "t-passwordConfirm-message",
        style: {
          color: "green"
        }
      }, "\u2713 Password Ok"), !asyncValidating && error !== "" && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, {
        id: "t-passwordConfirm-message"
      }, error));
    }
  }]);
  return Password;
}(_react.PureComponent);

var _default = Password;
exports["default"] = _default;